import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Wand2, Sparkles } from "lucide-react";
import { api } from "../lib/api";
import { Textarea } from "./ui/textarea";

export const DecisionAIBox = ({ disabled, getCtx, onResult }) => {
  const [prompt, setPrompt] = useState("");
  const [busy, setBusy] = useState("");
  const run = async (mode) => {
    setBusy(mode);
    try {
      const r = await api.decisionAI({ mode, prompt, ...getCtx() });
      onResult(r, mode);
      toast.success(mode === "improve" ? "تم تحسين الصياغة — راجع النص وعدّل ما تحتاج" : "تمت كتابة القرار — راجعه وعدّل ما تحتاج");
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر التوليد"); } finally { setBusy(""); }
  };
  return (
    <div className="rounded-xl border border-fuchsia-200 bg-gradient-to-b from-fuchsia-50 to-white p-2.5" data-testid="decision-ai-box">
      <p className="mb-1.5 flex items-center gap-1.5 text-xs font-bold text-fuchsia-800"><Sparkles className="h-3.5 w-3.5" /> الكتابة بالذكاء الاصطناعي</p>
      <Textarea value={prompt} onChange={(e) => setPrompt(e.target.value)} rows={3} disabled={disabled} data-testid="decision-ai-prompt"
        placeholder="صف القرار باختصار، مثال: قبول استقالة الموظف، آخر يوم 30/11، مع صرف المستحقات" className="bg-white text-sm" />
      <div className="mt-2 grid grid-cols-2 gap-1.5">
        <button type="button" disabled={disabled || !!busy} onClick={() => run("write")} data-testid="decision-ai-write"
          className="flex items-center justify-center gap-1 rounded-lg bg-fuchsia-700 py-2 text-xs font-bold text-white transition-colors hover:bg-fuchsia-800 disabled:opacity-50">
          {busy === "write" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Sparkles className="h-3.5 w-3.5" />} اكتب بالذكاء الاصطناعي
        </button>
        <button type="button" disabled={disabled || !!busy} onClick={() => run("improve")} data-testid="decision-ai-improve"
          className="flex items-center justify-center gap-1 rounded-lg border border-fuchsia-300 bg-white py-2 text-xs font-bold text-fuchsia-800 transition-colors hover:bg-fuchsia-50 disabled:opacity-50">
          {busy === "improve" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Wand2 className="h-3.5 w-3.5" />} تحسين الصياغة
        </button>
      </div>
    </div>
  );
};
